import {format} from 'date-fns-tz';
import {parseISO} from 'date-fns';

function formatDate( dt ){
  return format(parseISO(dt),"MMM-d-yyyy h:mm a z")
}

function getLastDateCodeAndInfo(dates,details){
  let lastDate = "";
  let code = "";
  let info = "";
  try{
    let count = dates.length;
    lastDate = formatDate(dates[count -1]);
    let lastDetail = details[count -1]
    let splitDetail = lastDetail.split("~")
    if (splitDetail.length > 0) code = splitDetail[0];
    if (splitDetail.length > 1) info = splitDetail[1];
  } catch (e){
    console.log(e);
  }
  return {lastDate:lastDate,code:code,info:info}  
}

export default {
  data: function(){return{
  }},  
  methods: {
    formatEventSummary(events, leadingBreak) {
      if (events) {
        let ret = '';
        if (events.o && events.o.length > 0) {
          let openCount = events.o.length;
          ret += `<span class='engagement-item d-inline-block mr-1 bg-success small'></span><b>Opens:</b> ${openCount}<br>`;
          let first = formatDate(events.o[0]);
          if (openCount > 1) {
            let last = formatDate(events.o[openCount -1]);
            ret += `<b>First Opened:</b> ${first}<br><b>Last Opened:</b> ${last}`
          } else {
            ret += `<b>Opened:</b> ${first}`
          }
        }
        if (events.c && events.c.length > 0) {
          ret += (ret.length) ? '<hr>' : '';
          let clickCount = events.c.length;
          ret += `<span class='engagement-item d-inline-block mr-1 bg-primary small'></span><b>Clicks:</b> ${clickCount}<br>`
          let first = formatDate(events.c[0]);
          if (clickCount > 1){
            let last = formatDate(events.c[clickCount -1]);
            ret += `<b>First Clicked:</b> ${first}<br><b>Last Clicked:</b> ${last}`
          } else {
            ret += `<b>Clicked:</b> ${first}`
          }
        }
        if (events.unsub && events.unsub.length == 2) {
          //unsub
          //expecting 2 arrays in the opt array, first is dates, second is details
          let dates = events.unsub[0];
          let details = events.unsub[1];
          if (dates.length > 0 && details.length > 0){
            //do the last one
            let {lastDate,code,info} = getLastDateCodeAndInfo(dates,details)
            ret += (ret.length) ? '<hr>' : '';
            ret += `<span class='engagement-item d-inline-block mr-1 bg-warning small'></span><b>Unsubcribed:</b> ${lastDate}`
            if (code) ret +=`<br><b>Code:</b> ${code}`; 
            if (info) ret += `<br><b>Info:</b> ${info}`;
          }

        }
        if (events.b && events.b.length == 2) {
          //last bounce
          //expecting 2 arrays in the bounce array, first is dates, second is details
          let dates = events.b[0];
          let details = events.b[1];
          if (dates.length > 0 && details.length > 0){
            let {lastDate,code,info} = getLastDateCodeAndInfo(dates,details)
            ret += (ret.length) ? '<hr>' : '';
            ret += `<span class='engagement-item d-inline-block mr-1 bg-yellow small'></span><b>Bounced:</b> ${lastDate}`
            if (code) ret +=`<br><b>Code:</b> ${code}`; 
            if (info) ret += `<br><b>Info:</b> ${info}`;
          }
        }
        if (events.comp && events.comp.length == 2) {
          let dates = events.comp[0];
          let details = events.comp[1];
          if (dates.length > 0 && details.length > 0){
            let {lastDate,code,info} = getLastDateCodeAndInfo(dates,details)
            ret += (ret.length) ? '<hr>' : '';
            ret += `<span class='engagement-item d-inline-block mr-1 bg-danger small'></span><b>Spam Complaint</b><br><b>Event date:</b> ${lastDate}`
            if (code) ret +=`<br><b>Code:</b> ${code}`; 
            if (info) ret += `<br><b>Info:</b> ${info}`;
          }
        }
        if (leadingBreak && ret.length) ret = '<hr>' + ret;
        ret = `<span class='event-pop-text'>${ret}</span>`;

        return ret;

      } else {
        return null;
      }
    },

    formatSmsEventSummary(events, leadingBreak) {
      if (events) {
        let ret = '';
        if (events.c && events.c.length > 0) {
          ret += (ret.length) ? '<hr>' : '';
          let clickCount = events.c.length;
          ret += `<span class='engagement-item d-inline-block mr-1 bg-primary small'></span><b>Clicks:</b> ${clickCount}<br>`
          let first = formatDate(events.c[0]);
          if (clickCount > 1){
            let last = formatDate(events.c[clickCount-1]);
            ret += `<b>First Clicked:</b> ${first}<br><b>Last Clicked:</b> ${last}`
          } else {
            ret += `<b>Clicked:</b> ${first}`
          }
        }
        if (events.sub && events.sub.length == 2) {
          //sub
          //expecting 2 arrays - first is dates, second is details
          let dates = events.sub[0];
          let details = events.sub[1];
          if (dates.length > 0 && details.length > 0){
            //do the last one
            let {lastDate,code,info} = getLastDateCodeAndInfo(dates,details)
            ret += (ret.length) ? '<hr>' : '';
            ret += `<span class='engagement-item d-inline-block mr-1 bg-success small'></span><b>Subcribed:</b> ${lastDate}`
            if (code) ret +=`<br><b>Code:</b> ${code}`; 
            // looks like the data is mostly 'unknown' for info, leaving this out
            // if (info) ret += `<br><b>Info:</b> ${info}`;
          }
        }
        if (events.unsub && events.unsub.length == 2) {
          //unsub
          //expecting 2 arrays - first is dates, second is details
          let dates = events.unsub[0];
          let details = events.unsub[1];
          if (dates.length > 0 && details.length > 0){
            //do the last one
            let {lastDate,code,info} = getLastDateCodeAndInfo(dates,details)
            ret += (ret.length) ? '<hr>' : '';
            ret += `<span class='engagement-item d-inline-block mr-1 bg-danger small'></span><b>Unsubcribed:</b> ${lastDate}`
            if (code) ret +=`<br><b>Code:</b> ${code}`;
            // looks like the data is mostly 'unknown' for info, leaving this out
            // if (info) ret += `<br><b>Info:</b> ${info}`;
          }
        }
        if (leadingBreak && ret.length) ret = '<hr>' + ret;
        ret = `<span class='event-pop-text'>${ret}</span>`;

        return ret;

      } else {
        return null;
      }
    },
  }
}